
import { computed, defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'ButtonHamburger',
  setup() {
    const isOpen = ref(false)

    const handleClick = () => {
      isOpen.value = !isOpen.value
    }

    const topBarStyles = computed(() => {
      return isOpen.value ? 'rotate-45 translate-y-2.5' : ''
    })

    const middleBarStyles = computed(() => {
      return isOpen.value ? 'opacity-0 h-0' : ''
    })

    const bottomBarStyles = computed(() => {
      return isOpen.value ? '-rotate-45 -translate-y-2.5' : ''
    })

    return {
      isOpen,
      handleClick,
      topBarStyles,
      middleBarStyles,
      bottomBarStyles,
    }
  },
})
